<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          color="primary"
          small
          dark
          v-bind="attrs"
          v-on="on"
          @click="open()"
          class="ml-1"
        >
          mdi-comment-question-outline
        </v-icon>
      </template>
      <span>Need Admin access to clients facebook page.</span>
    </v-tooltip>
    <v-navigation-drawer
      app
      temporary
      right
      disable-resize-watcher
      width="650px"
      v-model="show"
      class="actionDrawer"
    >
      <v-row class="mx-4 mt-4" justify="center" align="center">
        <v-col cols="2">
          <v-btn @click="clearOperation()" color="primary" icon>
            <v-icon>mdi-arrow-left-bold-circle</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="8" class="text-center">
          <v-img
            src="../../assets/Compeat-logo.jpg"
            width="280px"
            class="mx-auto"
          />
        </v-col>
        <v-col cols="2"> </v-col>
      </v-row>
      <v-row class="mx-4 my-4">
        <!-- <v-col v-if="alert" cols="12">
                     <generalAlert :alert="alert" :alertType="alertType" :message="successResponse" />
                </v-col> -->
        <v-col cols="12">
          <h2>Check For Access</h2>
          <p class="mb-0">
            The insights reports werent generated for the client. See if you
            have access now. If you still dont have access try signing out of
            facebook and signing back in.
          </p>
        </v-col>
        <v-col cols="12" class="py-0">
          <v-card flat>
            <v-btn rounded class="primary" @click="checkForPageAccess()">
              Check For Access
            </v-btn>
            <!-- <v-form ref="form" v-model="valid">
                            <v-card-text>
                                <v-textarea :rules="requiredRules" v-model="reason" label="Reason" auto-grow outlined rows="1"
                                    row-height="15"></v-textarea>
                                <v-btn :disabled="!valid" rounded class="primary"
                                    @click="cancellSubscriptions()">
                                    Submit
                                </v-btn>
                            </v-card-text>
                        </v-form> -->
          </v-card>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="120"
          ><p class="mb-0 overlaytext">Please Wait...</p></v-progress-circular
        >
      </v-overlay>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { getFunctions, httpsCallable } from "firebase/functions";
import { firebaseApp } from "../../firebaseConfig";
import generalAlert from "../alerts/generalAlert.vue";

export default {
  props: ["subscription"],
  components: {
    generalAlert,
  },
  data: () => ({
    show: false,
    valid: false,
    overlay: false,
    reason: "",
    requiredRules: [(v) => !!v || "This Field Is Required"],
    alert: false,
    alertType: "",
    successResponse: "",
  }),
  methods: {
    //open New Subscribtion Drawer and display over Layer
    open() {
      this.show = !this.show;
    },
    clearOperation() {
      this.reason = "";
      this.show = false;
    },
    checkForPageAccess() {
      this.overlay = true;
      const functions = getFunctions(firebaseApp, "europe-west2");
      const getPageToken = httpsCallable(functions, "getPageToken");

      console.log(
        "this.subscription.packages.pages[0].id",
        this.subscription[0].id
      );

      getPageToken({
        userToken: this.$store.state.user.facebookToken,
        pageId: this.subscription[0].id,
      }).then((result) => {
        console.log("result getting token", result);
        this.primaryPageToken = result.data;
        if (this.primaryPageToken == "") {
          this.emailClientForAccess = true;
          this.overlay = false;
        } else {
          this.getAdsAccounts = true;
          this.getAdsAccountsForPage(result);
        }
      });
    },
  },
};
</script>
